import { ITEM_KINDS } from '../../../constants/items';
import { STATES } from '../../../constants/states';
import { BASE_PATH } from './constants';
import { HomeServicesController } from './home-services.controller';

const template = `
  <div id="upd-home-services-app"></div>
`;

export default function HomeServicesConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.STEP_HOME_SERVICES_APP, {
    url: `${BASE_PATH}/{path: (?!checkout|confirmation).*}?utm_source&utm_campaign&ad_set&ad&showIntroBanner`,
    disableBreadcrumb: true,
    views: {
      '@': {
        template,
        controller: HomeServicesController,
      },
    },
    data: {
      permissions: 'signedIn',
      moveItem: {
        type: ITEM_KINDS.HOME_SERVICES_APP,
        singleton: true,
      },
    },
    analytics: {
      ignore: true,
    },
    scrollTop: true,
    title: 'Connect TV & Internet',
  });
}
